import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<RouteError::NotFound />",{ moduleName: "glesys-controlpanel/not-found/template.hbs" })